import type { Styles } from 'src/theme/themes';

export const styles = {
  // Widget footer
  footer: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    height: '100%',
    padding: '1rem 1.5rem',
    flexWrap: 'wrap',
  },
  footerCircle: {
    width: '1rem',
    height: '1rem',
    borderRadius: '1rem',
  },
} satisfies Styles;
